export default {"src":"/_next/static/media/iconDark.8508137e.svg","height":48,"width":48};